<div class="border-card border-0 px-4 py-1 overflow-auto">
  <div class="card-header card-header-primary text-white shadow rounded-lg mt-3">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="rounded-lg me-2 nav-item">
              <a class="text-dark text-decoration-none text-x fw-bold nav-link" href="#profile" data-toggle="tab">
                Trust Directory
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  <div class="card mt-2 rounded-lg border-0 shadow">
    <div class="card-body">
      <div class="quick-tip d-flex align-items-center m-2 rounded-lg mb-3">
        <i class="fa-solid fa-check-double fs-6 text-primary-green me-2"></i>
        <p class="text-xxs mb-0 fw-bold">Manage your trust directory entries</p>
      </div>
        <GlobalTable
          :headers="table_headers"
          :data="sanitized_applicants"
          table_id="trust_directory_table"
          key="trust_directory"
        >
          <template #actions="{ row }">
            <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs">
              Edit
            </button>
            <button 
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2" 
              @click="redirect_to_view_approved_applicant(row.ID)">
              View
            </button>
          </template>
        </GlobalTable>
        
        
    </div>
  </div>
</div>